import Highcharts from "highcharts"

/**
 * Global Highcharts configuration
 *
 * This configuration disables the exporting module in development to prevent
 * slow chart loading caused by trying to contact external export servers.
 *
 * Issue: Highcharts by default tries to load the exporting module which contacts
 * export.highcharts.com, causing significant delays in local development due to
 * network latency or timeouts.
 */
Highcharts.setOptions({
  exporting: {
    enabled: false, // Disable exporting to prevent external server calls
  },
})

// All useHTML content (e.g. our HTML tooltip formatters) is sanitized through Highcharts' AST
// allowlist, which silently strips unknown tags/attributes. The tooltip series swatch is a
// rounded rect whose corner radius and dashed outline need these two; without them a projected
// series' swatch renders as a solid square.
Highcharts.AST.allowedAttributes.push("rx", "stroke-dasharray")

// React 19's dev-only "Components" performance track serializes every committed component's
// props. For <HighchartsReact highcharts={Highcharts}/> it walks Highcharts.win (= window) →
// window.frames[0], a cross-origin iframe (Intercom/Survicate), and reading $$typeof on it
// throws a SecurityError that aborts the commit. Hiding `win` from the for…in walk avoids it;
// direct access (Highcharts.win) is unaffected by enumerability.
Object.defineProperty(Highcharts, "win", { enumerable: false })

export default Highcharts
